import { ServiceFetch } from '../service-fetch'

export default class ShortcutProductModel extends ServiceFetch {
    getShortcutProductBy = (data) => this.authFetch({
        url: 'shortcut-product/getShortcutProductBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}